import { supabase } from "@/integrations/supabase/client";

export type TipoExplicacao =
  | 'destino' | 'missao' | 'expressao' | 'motivacao' | 'impressao'
  | 'ano_pessoal' | 'psiquico' | 'talento_oculto' | 'harmonia_conjugal'
  | 'resposta_subconsciente' | 'tendencia_oculta' | 'licao_carmica'
  | 'divida_carmica' | 'arcano'
  | 'primeiro_ciclo_vida_e_desafio' | 'segundo_ciclo_vida_e_desafio' | 'terceiro_ciclo_vida_e_desafio'
  | 'primeiro_momento_decisivo' | 'segundo_momento_decisivo' | 'terceiro_momento_decisivo' | 'quarto_momento_decisivo'
  | 'triangulo_invertido_vida' | 'triangulo_invertido_pessoal' | 'triangulo_invertido_social' | 'triangulo_invertido_destino'
  | 'cores_expressao';

export type NeededMap = Record<TipoExplicacao, Set<number | null>>;

export async function fetchExplicacoesBulk(needed: NeededMap) {
  const entries = Object.entries(needed).filter(([, set]) => set.size > 0) as [TipoExplicacao, Set<number|null>][];
  const result = new Map<string, string>(); // chave: `${tipo}#${numero|null}`

  await Promise.all(entries.map(async ([tipo, set]) => {
    const nums = [...set].filter(n => n !== null) as number[];
    const wantsNull = [...set].some(n => n === null);

    const calls = [];
    if (nums.length) {
      calls.push(
        supabase.from('explicacoes_numeros')
          .select('tipo_numero, numero, descricao')
          .eq('tipo_numero', tipo)
          .in('numero', nums)
      );
    }
    if (wantsNull) {
      calls.push(
        supabase.from('explicacoes_numeros')
          .select('tipo_numero, numero, descricao')
          .eq('tipo_numero', tipo)
          .is('numero', null)
      );
    }

    const pages = await Promise.all(calls);
    for (const { data } of pages) {
      for (const row of (data || [])) {
        const key = `${row.tipo_numero}#${row.numero ?? 'null'}`;
        result.set(key, row.descricao);
      }
    }
  }));

  const get = (tipo: TipoExplicacao, numero?: number | null) =>
    result.get(`${tipo}#${numero ?? 'null'}`) ?? null;

  return { get };
}